// extracted by mini-css-extract-plugin
export default {"photo-container":"Swiper_photo-container__kNMsb"};